// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_PNz","inner":"styles_inner__32KCl","right":"styles_right__29LaU","close":"styles_close__31mwq","footer":"styles_footer__31GRH"};